import { Divider } from 'antd';
import React, { useState } from 'react';

import styles from '../styles/PharmacyNote.module.less';
import { CreditNoteDetails } from './CreditNoteDetails';
import { PharmacyNotePreview } from '../PharmacyNotePreview';

interface IProps {
	noteId?: string;
	pharmacyId?: string;
	editMode?: boolean;
}

export const CreditNote = (props: IProps) => {
	const [noteAttachment, setNoteAttachment] = useState<Blob>();

	const setAttachment = (attachment: Blob | undefined) => {
		setNoteAttachment(attachment);
	};

	return (
		<div className={styles.note}>
			<CreditNoteDetails
				noteId={props.noteId}
				readOnly={props.noteId !== undefined}
				pharmacyId={props.pharmacyId}
				editMode={props.editMode}
				setAttachment={setAttachment}
			/>
			<Divider className={styles.divider} type="vertical" />
			<PharmacyNotePreview blob={noteAttachment} />
		</div>
	);
};
